/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * The type of the meter reading fuel
 */
export type ReadingFuelEnum =
  (typeof ReadingFuelEnum)[keyof typeof ReadingFuelEnum]

export const ReadingFuelEnum = {
  Elec: "Elec",
  Gas: "Gas",
  Dual: "Dual",
} as const
